import lazySizes from 'lazysizes';

var LAZY_CLASS_NAME = 'lazy';
var initLazySizes = function initLazySizes() {
  lazySizes.cfg.lazyClass = LAZY_CLASS_NAME;
  lazySizes.cfg.loadedClass = "".concat(LAZY_CLASS_NAME, "loaded");
};

export { LAZY_CLASS_NAME, initLazySizes };
